export default class LopaConfig {
    getAPIPath = function () {
        return '/v2/metrics/flight_list_data';
    };
}
